var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "status-chip",
      class: "status-chip--" + _vm.status,
      attrs: {
        "data-testid": "status-chip",
        "aria-label": _vm.$t("label." + _vm.status),
      },
    },
    [
      _c("span", { staticClass: "status-chip__dot" }),
      _vm._v("\n  " + _vm._s(_vm.$t("label." + _vm.status)) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }